import script from "./KfServicerModal.vue?vue&type=script&setup=true&lang=js"
export * from "./KfServicerModal.vue?vue&type=script&setup=true&lang=js"

import "./KfServicerModal.vue?vue&type=style&index=0&id=702bdee9&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-702bdee9"]])

export default __exports__